import React from 'react';
import {
  RiHome7Line,
  RiContactsLine,
  RiCalendarCheckLine,
  RiShoppingCart2Line,
  RiBroadcastLine,
  RiTicket2Line,
} from 'react-icons/ri';

export const MENUITEMS = [
  {
    position: 1,
    icon: <RiHome7Line />,
    label: 'Home',
    subtitle: 'All of me in one place',
    isComing: false,
    URL: '/s/',
  },
  {
    position: 2,
    icon: <RiContactsLine />,
    label: 'Add Yourself',
    subtitle: 'Add yourself to my phone book',
    isComing: false,
    URL: '/f/',
  },
  {
    position: 3,
    icon: <RiCalendarCheckLine />,
    label: 'Book Me',
    subtitle: 'Schedule time with me',
    isComing: false,
    URL: '/b/',
  },
  {
    position: 4,
    icon: <RiShoppingCart2Line />,
    label: 'Shop',
    subtitle: 'See my offerings',
    isComing: true,
    URL: '#',
  },
  {
    position: 5,
    icon: <RiTicket2Line />,
    label: 'Tickets & Events',
    subtitle: 'See upcoming events',
    isComing: false,
    URL: '/e/',
  },
  {
    position: 6,
    icon: <RiBroadcastLine />,
    label: 'Exclusive Content',
    subtitle: 'Subscribe to get access',
    isComing: true,
    URL: '#',
  },
];

export default MENUITEMS;
